<template>
  <div class="tc-profiles">
    <div class="tc-profiles-select">
      <el-popover
        popper-class="r-popover tc-profiles simple"
        placement="bottom-end"
        trigger="click"
        v-model="profilePopover"
        width="280"
      >
        <div class="tc-profiles-popover">
          <div class="tc-profiles-popover__create-button">
            <button @click="createNewProfile">
              <r-text>
                Добавить новый профиль
              </r-text>
            </button>
          </div>
          <ul class="tc-profiles-popover__list">
            <li
              :class="
                `tc-profiles-popover__item ${
                  profile === item.id ? 'active' : ''
                } `
              "
              v-for="item in profiles"
              :key="item.id"
              @click="changeProfile(item.id)"
            >
              <div class="tc-profiles-popover__info">
                <r-text>{{ item.name }}</r-text>
              </div>
              <div class="tc-profiles-popover__actions">
                <button @click.stop="editProfileName(item)">
                  <r-icon name="settings" :size="12" :color="primaryColor" />
                </button>
                <button @click.stop="beforeDeleteProfile(item.id)">
                  <r-icon name="trash" :size="11" :color="dangerColor" />
                </button>
              </div>
            </li>
          </ul>
        </div>
        <el-button class="tc-profiles-button" slot="reference">
          <span>{{ currentProfileName }}</span>
          <i
            :class="
              profilePopover ? 'el-icon-arrow-down' : 'el-icon-arrow-right'
            "
          />
        </el-button>
      </el-popover>
    </div>
    <div class="tc-profiles-content">
      <div v-if="profile && coefficients.length">
        <r-text type="caption" style="margin-bottom: 4px;">
          Настройте коэффициенты приведения для данного профиля
        </r-text>
        <ul class="tc-profiles-coefficients">
          <transport-system-item
            v-for="item in coefficients"
            :key="item.sys_set_measure_id"
            :system="item"
            :loading-item="loadingItem"
          >
            <el-input-number
              size="mini"
              class="r-input"
              v-model="item.value"
              :min="0"
              :step="0.05"
              @change="changeCoef($event, item.id)"
            />
          </transport-system-item>
        </ul>
      </div>
      <div class="tc-profiles-nodata" v-else>
        <r-text type="caption">
          Выберите или создайте новый профиль
        </r-text>
      </div>
    </div>

    <el-dialog
      class="modal-window"
      title="Введите название профиля"
      :visible.sync="showNameModal"
      :show-close="false"
      :append-to-body="true"
      width="320px"
    >
      <el-input class="r-input" v-model="profileName" />
      <span slot="footer" class="dialog-footer">
        <el-button class="r-button simple" @click="closeModal">
          Отменить
        </el-button>
        <el-button
          class="r-button"
          type="primary"
          @click="saveProfile"
          :disabled="!profileName"
          :loading="saving"
        >
          Сохранить
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TransportSystemItem from "./transport-system-item";
import variables from "@/styles/variables.scss";

export default {
  props: ["controller"],
  components: {
    TransportSystemItem
  },
  data() {
    return {
      ids: this.$store.state.trafficCount.model.ids,
      coefficients: [],
      profilePopover: false,
      showNameModal: false,
      profileName: "",
      editingProfile: "",
      saving: false,
      loadingItem: null,
      primaryColor: variables.primaryColor,
      dangerColor: variables.dangerColor
    };
  },
  computed: {
    systems() {
      return this.$store.state.trafficCount.model.transport_systems;
    },
    profiles() {
      return this.$store.state.trafficCount.model.profiles;
    },
    profile: {
      get() {
        return this.$store.state.trafficCount.fill.profile;
      },
      set(value) {
        this.$store.commit("SET_TC_FILL_PROP", { name: "profile", value });
      }
    },
    currentProfileName() {
      if (!this.profile) return "Выберите профиль";

      return this.profiles.find(p => p.id === this.profile).name;
    }
  },
  methods: {
    changeProfile(id) {
      const profile = this.profiles.find(p => p.id === id);
      const { coefficients } = profile;

      this.profile = id;
      this.coefficients = coefficients
        .map(({ value, id, sys_set_measure_id }) => {
          const system = this.systems.find(s => s.id === sys_set_measure_id);
          const { name, category, code } = system;

          return {
            name,
            category,
            code,
            value,
            sys_set_measure_id,
            id
          };
        })
        .sort((a, b) => {
          if (a.code > b.code) return 1;
          if (a.code < b.code) return -1;
          return 0;
        });
      this.profilePopover = false;
    },
    editProfileName({ id, name }) {
      this.profilePopover = false;
      this.profileName = name;
      this.editingProfile = id;
      this.showNameModal = true;
    },
    createNewProfile() {
      this.profilePopover = false;
      this.showNameModal = true;
    },
    getData() {
      if (this.editingProfile) {
        return { id: this.editingProfile, name: this.profileName };
      } else {
        const coefficients = this.systems.map(({ id }) => ({
          sys_set_measure_id: id,
          value: 1
        }));

        return {
          name: this.profileName,
          coefficients
        };
      }
    },
    async saveProfile() {
      try {
        this.saving = true;
        const url = `objectInfo/${this.ids["coefficient_profiles"]}`;
        const data = this.getData();
        await this.$store.dispatch("POST_REQUEST", { url, data });
        await this.controller.setProfiles(this.ids);
        this.profileName = "";
        this.editingProfile = "";
        this.showNameModal = false;
        this.saving = false;
      } catch (error) {
        console.log(error);
        this.saving = false;
      }
    },
    beforeDeleteProfile(id) {
      const warningText = "Предупреждение";
      const warningTitle = "Профиль будет удален. Продолжить?";
      const confirmButtonText = "Да";
      const cancelButtonText = "Отмена";
      this.profilePopover = false;
      this.$confirm(warningText, warningTitle, {
        customClass: "r-message-box",
        type: "warning",
        confirmButtonText,
        cancelButtonText
      })
        .then(() => {
          this.deleteProfile(id);
        })
        .catch(() => {});
    },
    async deleteProfile(id) {
      try {
        const url = `objectInfo/${this.ids["coefficient_profiles"]}?id=${id}`;
        await this.$store.dispatch("DELETE_REQUEST", { url });
        await this.controller.setProfiles(this.ids);
      } catch (error) {
        console.log(error);
      }
    },
    async changeCoef(value, id) {
      try {
        const url = `objectInfo/${this.ids["coefficients"]}`;
        const cofficient_profile_id = this.profile;
        const data = { id, value, cofficient_profile_id };
        await this.$store.dispatch("POST_REQUEST", { url, data });
        this.setProfileCoefficient(id, value);
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showNameModal = false;
      this.profileName = "";
      this.editingProfile = "";
    },
    setProfileCoefficient(id, value) {
      const { coefficients } = this.profiles.find(p => p.id === this.profile);
      const coef = coefficients.find(c => c.id === id);
      this.$set(coef, "value", value);
    }
  },
  created() {
    if (this.profile) this.changeProfile(this.profile);
  }
};
</script>

<style lang="scss">
.tc-profiles {
  &-select {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    & > span {
      width: 100%;
    }
  }

  &-button {
    width: 100%;
    background-color: var(--field_bg) !important;
    border-color: var(--field_border) !important;
    color: var(--text_secondary) !important;

    & > span {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &-nodata {
    text-align: center;
    padding: 0 0 16px;
  }

  &-coefficients {
    padding: 8px 0;
    max-height: 40vh;
    overflow: auto;
  }

  .el-input-number {
    width: 112px !important;
  }

  &-popover {
    padding: 4px 0 0;
    button {
      cursor: pointer;
      background: transparent;
      border: none;
      padding: 0;
      &:focus {
        outline: none;
      }
    }

    &__create-button {
      margin-bottom: 4px;

      button {
        width: 100%;
        padding: 8px 8px;
      }

      &:hover {
        background-color: rgba(var(--accent_primary), 0.2);
      }
    }

    &__list {
      padding: 8px 0;
      border-top: 1px solid transparent;
      border-color: var(--dividers_low_contrast) !important;
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 8px;
      cursor: pointer;

      &.active {
        background-color: rgba(var(--accent_primary), 0.4) !important;
      }

      &:hover {
        background-color: rgba(var(--accent_primary), 0.2);

        .tc-profiles-popover__actions {
          display: block;
        }
      }
    }

    &__info {
      margin-right: 16px;
      line-height: 24px;
    }

    &__actions {
      display: none;

      button {
        opacity: 0.4;

        &:hover {
          opacity: 1;
        }

        &:not(:last-child) {
          margin-right: 12px;
        }
      }
    }
  }
}
</style>
